/* eslint-disable camelcase */
const en_us = {
    values: {
        'must not be empty': 'must not be empty',
        'Idle connection test period': 'Idle connection test period',
        'in seconds': 'in seconds',
        'Validation query': 'Validation query',
        'Max pool size': 'Max pool size',

        'SQL Events configuration': 'SQL Events configuration',
        'Add event type': 'Add event type',
        'These event types will be retrieved directly from the SQL database when used in Pipes queries':
            'These event types will be retrieved directly from the SQL database when used in Pipes queries',
        'Enable the instance as Storage to use this feature': 'Enable the instance as Storage to use this feature',
        'Pipes event name': 'Pipes event name',
        'Query template': 'Query template',
        'Valid placeholders on query template': 'Valid placeholders on query template',
        'Available fields': 'Available fields',
        'Pipes name': 'Pipes name',
        'SQL Expression': 'SQL Expression'
    }
}

module.exports = en_us
